import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import {getParam} from '../utils/utils';

import Buffering from "../components/Buffering"; 

import dsd from "../classes/clsDSD";

import D3Graphviz from "../components/D3Graphviz";


import { addSerializationToDataSpec, editSerialization, deleteSerialization, getSerialization, getDataSpec, getSerializationJsonSchema, getSerializationXSD } from "../utils/utilsDataSpec";
import TreeSerialization from "../components/TreeSerialization";


import ViewSerialization from "../components/ViewSerialization";
import ViewDataSpec from "../components/ViewDataSpec";
import ViewMetadata from "../components/ViewMetadata";

import FormElement from "../components/FormElement";

import Revision from "../components/Revision";
import ListRevisions from "../components/ListRevisions";

import Rendition from '../components/Rendition';

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class Serialization extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.refRevision = React.createRef();
        this.loadedRevisions = this.loadedRevisions.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/`;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadDataSpec(id){

        const onLoad = (data) => {
            let StateChange = {
                DataSpec: data,
                renderState: "loaded"
            };

            // Initialize FormData for 'new' mode
            if (this.state.mode === 'new'){
                StateChange.FormData = {status: 'in use'};
            }

            // Check edit permissions
            StateChange.OfferEdit = false;
            if (this.dsd.loggedon){
                if (this.dsd.user.id === data.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "delete":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Serializations to this Data Spec";
                        break;
                }
            }

            this.setState(StateChange);
        };

        const onFail = (e) => {
            let StateChange = {
                DataSpec: null,
                renderState: "failed",
                errorMessage: e.message
            };
            if (e.response && e.response.data && e.response.data.message){
                StateChange.errorMessage = e.response.data.message;
            }
            this.setState(StateChange);
        };

        if (id){
            this.setState({ renderState: "loading" });
            getDataSpec(this.dsd, id, onLoad, onFail);
        }
        
    };

    loadSerialization(id){

        const onLoad = (data) => {
            let StateChange = {
                Serialization: data,
                FormData: data,
                renderState: "loaded"
            };

            if (data.DataSpec){
                StateChange.DataSpec = data.DataSpec;
                StateChange.idDataSpec = data.DataSpec._id;
                this.FallBackNavigation = `/dataspec/${StateChange.idDataSpec}`;
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsDataSpec(data.DataSpec._id);
                }
            }

            // Check edit permissions
            StateChange.OfferEdit = false;
            if (StateChange.DataSpec){
                if (this.dsd.loggedon){
                    if (this.dsd.user.id === StateChange.DataSpec.idUser){
                        StateChange.OfferEdit = true;
                    }
                }
            }

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "edit":
                    case "delete":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Serializations to this Data Spec";
                        break;
                }
            }

            this.setState(StateChange);

            this.fetchViz(id);
        };

        const onFail = (e) => {
            let StateChange = {
                Serialization: null,
                renderState: "failed",
                errorMessage: e.message
            };
            if (e.response && e.response.data && e.response.data.message){
                StateChange.errorMessage = e.response.data.message;
            }
            this.setState(StateChange);
        };

        if (id){
            this.setState({ renderState: "loading" });
            getSerialization(this.dsd, id, onLoad, onFail);
        }
        
    };

    fetchViz(id) {

        const onDoneDot = function(dot) {
            this.setState({ dot: dot });
        }.bind(this);

        const onFailDot = function(error) {
            console.error('Failed to fetch DOT:', error);
        }.bind(this);

        getSerialization(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

    };

    setup(){

        let StateChange = {

            mode: "view",

            idSerialization: null,
            idDataSpec: null,

            DataSpec: null,
            Serialization: null,

            isUpdated: false,
            isDeleted: false,

            isFailed: false,
            isError: false,
            errorMessage: null,

            renderState: null,

            FormData: {},
            OfferEdit: false,

            Controls: {},

            countRevisions: null,

            dot: null

        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idSerialization = getParam('id', this.props);
        StateChange.idDataSpec = getParam('idDataSpec', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idDataSpec){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Data Spec not specified when adding a Serialization"
                }
                break;
            default:
                if (StateChange.idDataSpec){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Data Spec should not be specified for an existing Serialization"
                }
                if (!StateChange.idSerialization){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Serialization not specified for an existing Serialization"
                }
                break;
        }

        if (StateChange.mode == "new"){
            if (StateChange.idDataSpec){
                this.FallBackNavigation = `/dataspec/${StateChange.idDataSpec}`;
            }        
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);

        // Load data directly
        if (StateChange.idDataSpec && StateChange.mode === 'new'){
            this.loadDataSpec(StateChange.idDataSpec);
        }

        if (StateChange.idSerialization){
            this.loadSerialization(StateChange.idSerialization);
        }
        
    };

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleSubmit(event) {

        const onAdd = (idSerialization) => {
            this.props.navigation(`/serialization/${idSerialization}`);
        };

        const onUpdate = () => {
            this.refRevision.current.update();
            this.props.navigation(`/serialization/${this.state.idSerialization}`);
        };

        const onDelete = () => {
            this.props.navigation(this.FallBackNavigation);
        };

        const onError = (error) => {
            this.setState({
                isError: true,
                renderState: error.status || "error",
                errorMessage: error.errorMessage
            });
        };

        window.scrollTo(0, 0);

        switch (event.target.name){
            
            case 'btnCancel':

                switch (this.state.mode){
                    case 'edit':
                    case 'delete':
                        this.props.navigation(`/serialization/${this.state.idSerialization}`);
                        break;
                    case 'new':
                        this.props.navigation(this.FallBackNavigation);
                        break;
                }

                break;
            case 'btnDelete':
                deleteSerialization(this.dsd, this.state.idDataSpec, this.state.idSerialization, onDelete, onError);
                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    renderState: "updating"
                })
        
                switch (this.state.mode){
                    case 'new':
                        addSerializationToDataSpec(this.dsd, this.state.idDataSpec, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editSerialization(this.dsd, this.state.idSerialization, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };



    addProperty(){
        let FormData = {...this.state.FormData};
        FormData.Properties = [...(FormData.Properties || []), {}];
  
        this.setState({"FormData": FormData});
    }

    removeProperty(seq){

       let FormData = {...this.state.FormData};
       FormData.Properties = [...(FormData.Properties || [])];
       FormData.Properties.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});

    }


    movePropertyUp(seq){

        let FormData = {...this.state.FormData};
        FormData.Properties = [...(FormData.Properties || [])];
        
        // Swap with previous item
        [FormData.Properties[seq-2], FormData.Properties[seq-1]] =
        [FormData.Properties[seq-1], FormData.Properties[seq-2]];
        
        this.setState({"FormData": FormData});

    }

    movePropertyDown(seq){

       let FormData = {...this.state.FormData};
       FormData.Properties = [...(FormData.Properties || [])];
      
       // Swap with next item
       [FormData.Properties[seq-1], FormData.Properties[seq]] =
       [FormData.Properties[seq], FormData.Properties[seq-1]];
      
       this.setState({"FormData": FormData});

    }


    updateProperty(seq, Property){

       let FormData = {...this.state.FormData};
       FormData.Properties = [...(FormData.Properties || [])];
       FormData.Properties[seq-1] = Property;

       this.setState({"FormData": FormData});

    }


    handleVizClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'structure':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/structure/${partsVizNodeId[1]}`);
                    }
                    break;
            }
        }

        event.preventDefault();

    };


    loadedRevisions(count) {

        let StateChange = {};

        StateChange.countRevisions = 0;
        if (count){
            StateChange.countRevisions = count;
        }

        this.setState(StateChange);


    };


    visualise(){
    
        if (!this.state.Serialization){
            return null;
        }



        try {

            return(
                <D3Graphviz dot={this.state.dot} onClick={this.handleVizClick}/>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }


        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":

                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Serialization</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                                }

                                <form> 
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <fieldset>
                                        <legend>Elements</legend>                              
                                        {this.FormRootElement()}
                                    </fieldset>


                                    <Revision ref={this.refRevision}  idAbout={this.state.idSerialization}/>

                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'delete':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Serialization</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button name="btnDelete" onClick={this.handleSubmit} type="warning" value="confirm delete?" />
                        <PD.Button name="btnCancel" onClick={this.handleSubmit} type="warning" value="cancel" />
                        <ViewSerialization Serialization={this.state.Serialization}/>
                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        let countProperties = 0;
                        if (this.state.Serialization.Properties){
                            countProperties = this.state.Serialization.Properties.length;
                        }

                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Serialization:{this.state.Serialization.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                            <PD.Button onClick={this.handleMode} type="submit" value="delete" />
                                    </span>
                                }

                                <ViewSerialization Serialization={this.state.Serialization}/>

                                <br/>

                                <PD.Tabs>

                                    <div label='Visualise'>
                                        {this.visualise()}
                                    </div>

                                    <div label='Elements'>
                                        <TreeSerialization idSerialization={this.state.idSerialization}/>                                    
                                    </div>

                                    <div label='Data Spec'>
                                        <ViewDataSpec DataSpec={this.state.DataSpec} />
                                    </div>

                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Serialization} />
                                    </div>

                                    <div label={<span>Revisions({this.state.countRevisions === null ? <Buffering/> : this.state.countRevisions})</span>} data-forcerender="true">
                                        <ListRevisions OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idSerialization}} onLoad={this.loadedRevisions}/>
                                    </div>

                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/serializations"
                                            id={this.state.idSerialization}
                                        />
                                    </div>


                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };

    FormRootElement(){

        if (!this.state.FormData.Root){
            let FormData = this.state.FormData
            FormData.Root = {};
            this.setState({"FormData": FormData}); 
        }

        let Classes = null;
        if (this.state.DataSpec){
            if (this.state.DataSpec.Classes){
                Classes = this.state.DataSpec.Classes;
            }
        }

        const updateElement = function(seq, Element){
            let FormData = this.state.FormData;
            FormData.Root = Element;
            this.setState({"FormData": FormData});
        }.bind(this);
    

        return(
            <div>
                <FormElement
                    key="0"
                    mode="edit"
                    onUpdate={updateElement}
                    Classes={Classes}
                    Element={this.state.FormData.Root}
                    seq={0}/>
            </div>
        )
    
    };

    
    

};

// Wrap and export
export default function Serialization_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Serialization {...props} navigation={navigation} location={location} params={params} />;
  }
